import { render, staticRenderFns } from "./CallsSetting.vue?vue&type=template&id=6d266864&scoped=true&"
import script from "./CallsSetting.vue?vue&type=script&lang=js&"
export * from "./CallsSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d266864",
  null
  
)

export default component.exports